/**
 * `POST /Otp/verify` — endpoint **public** du user-service (guide v2.3 §6.9).
 *
 * Usage unique : un code accepté est purgé de TOUS les canaux (sinon un envoi
 * `BOTH` resterait consommable une seconde fois). `recipientAddress` doit
 * reprendre la même valeur qu'à l'envoi (en `BOTH` : `téléphone,email`).
 * Un code faux, expiré, utilisé ou bloqué donne la même réponse 400 avec
 * `isValid=false` — l'UI ne doit pas distinguer les cas.
 */
import { useMutation } from "@tanstack/react-query";

import { mutatePublicData } from "@/core/api/api-methods";
import {
  apiErrorHandler,
  getBackendErrorMessage,
} from "@/core/api/api-error-handler";
import { logger } from "@/core/utils/func/logger";
import { authEndpoints } from "@/features/auth/api/endpoints";
import type {
  OtpVerifyRequest,
  OtpVerifyResponse,
} from "@/features/auth/api/dto";

export const useVerifyOtp = () =>
  useMutation({
    mutationKey: ["auth", "otp", "verify"],
    mutationFn: (body: OtpVerifyRequest) =>
      mutatePublicData({
        url: authEndpoints.otp.verify,
        reqBody: body as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<OtpVerifyResponse>,
    onError: (error) => {
      // Un code faux lève par le backend un 400 : on ne logue qu'au cas « lourd ».
      const message = getBackendErrorMessage(error) ?? apiErrorHandler(error);
      logger.debug(
        `useVerifyOtp rejection: ${message}`,
        { prefix: "auth" }
      );
    },
  });
